import { showSwal } from '../pages/sweet-alert.js';

export default function ordersComponent() {

    return {

        initOrders(authID = null) {
            // Your initialization logic here
            console.log('Leads Initialized ' + authID);
        },

        filterOrders() {
            DatatableOrders();
        },
        getOrderStack() {
            let ordersIds = [];
            $('input[name="check_item"]:checked').each(function () {
                ordersIds.push($(this).attr('order-id'));
            });

            return ordersIds;
        },
        async showOrder(id) {
            const url = `/orders/show/${id}`;
            await ERPHelpers.loadModalContent('addEditModal', url);
        },

        async editOrder(id) {
            const url = `/orders/view/${id}`;
            await ERPHelpers.loadModalContent('addEditModal', url);
        },

        async closeOrder(id) {
            const url = `/orders/close/${id}`;
            await ERPHelpers.loadModalContent('addEditModal', url);
        },

        async showOrdersTransaction() {
            $("#addEditModal .modal-body.create-a-shipping-company-invoice").html('');
            if (!ordersCreateTransactionIds.length) {
                showSwal('custom-wrong', 'يجب اختيار اوردر واحد على الاقل');
                return;
            }
            let url = '/transactions/show-modal?';
            for (let order of ordersCreateTransactionIds) {
                url += `orders[]=${order}&`;
            }
            url = url.substring(0, url.length - 1);

            // Use ERPHelpers for modal loading
            await ERPHelpers.loadModalContent('addEditModal', url);
        },


        // assignOrdersToCS($event) {
        //     var selected_cs = $('#responsible_the_follow_up option:selected').val();
        //     var employee_id = $('#responsible_the_follow_up').data('employee'); //admin assigning or CS Team Leader
        //     Swal.fire({
        //         title: "Are you sure ?",
        //         text: "You will change the status of this task.",
        //         type: "warning",
        //         showCancelButton: true,
        //         confirmButtonText: "Yes, change it !",
        //         cancelButtonText: "No, cancel !",
        //         closeOnConfirm: false,
        //         closeOnCancel: false
        //     }).then((confirmed) => {
        //         console.log(confirmed);
        //         if (confirmed.value == true) {
        //             axios.post(`/api/order/cs/multiple`, {
        //                 selected_cs: selected_cs,
        //                 selected_agent: employee_id,
        //                 ordersIds: ordersStack,
        //             })
        //                 .then(function (response) {
        //                     document.getElementById('hand-follow-up').click();
        //                     showSwal('successful-opperation', response.data.message);
        //                     ordersStack = [];
        //                     // initializeDatatable();
        //                     DatatableOrders();
        //                 }, error => {
        //                     showSwal('something-wrong', '');
        //                 });
        //
        //         } else if (confirmed.dissmiss == "cancel") {
        //             Swal.fire("Cancelled", "Status Unchanged !", "error");
        //         }
        //     });
        //
        // },
        closeModalOrder($event, id) {
            // Close the modal properly using Bootstrap 5 API
            const modal = document.getElementById('addEditModal');
            if (modal) {
                const bootstrapModal = bootstrap.Modal.getInstance(modal);
                if (bootstrapModal) {
                    bootstrapModal.hide();
                } else {
                    // Fallback if no instance exists
                    $('#addEditModal').modal('hide');
                }

                // Listen for modal hidden event to clean up properly
                modal.addEventListener('hidden.bs.modal', () => {
                    this.cleanupModalState();
                }, { once: true });

                // Fallback cleanup in case event doesn't fire
                setTimeout(() => {
                    this.cleanupModalState();
                }, 300);
            }

            // Refresh the data table
            DatatableOrders();
        },

        cleanupModalState() {
            // Only clean up if no modals are currently open
            const openModals = document.querySelectorAll('.modal.show');
            if (openModals.length > 0) {
                return; // Don't clean up if another modal is open
            }

            // Remove any remaining backdrop elements
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => backdrop.remove());

            // Remove modal-open class from body only if no modals are open
            document.body.classList.remove('modal-open');

            // Reset body styles more carefully
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('padding-right');

            // Only force scroll if body was actually locked
            if (document.body.style.overflow === 'hidden') {
                document.body.style.overflow = '';
            }

            // Ensure scrolling works
            if (getComputedStyle(document.body).overflow === 'hidden') {
                document.body.style.overflow = 'auto';
            }
        },
        sendMsgWhats($event, orderId, phone) {
            var msgText = $(`#msg-whats-app-${orderId}`).val();
            if (phone.toString().substring(0, 2) == '01') {
                phone = '+2' + phone;
            } else if (phone.toString().substring(0, 1) == '1') {
                phone = '+20' + phone;
            } else if (phone.toString().substring(0, 2) == '20') {
                phone = '+' + phone;
            }
            $(this).attr('href', `https://web.whatsapp.com/send?phone=${phone}&text=${msgText}`);
            window.open(this.href, 'mywin', 'left=20,top=20,width=500,height=500,toolbar=1,resizable=0');
            return;
        },
        updateNoAnswer($event, id) {
            var btn_no_answer = document.getElementById('btnNoAnswer-' + id);

            axios.post(`/api/order/${id}/updatenoanswer`, {})
                .then(function (response) {
                    showSwal('successful-opperation', response.data.message);

                    var btnText = '';
                    if (btn_no_answer.getAttribute('data-role') == 'cs') {
                        btnText = response.data.data.cs_no_answer_count;
                    } else if (btn_no_answer.getAttribute('data-role') == 'shipping') {
                        btnText = response.data.data.shipping_no_answer_count;
                    }

                    btn_no_answer.innerHTML = `Client Did Not Answer ( ${btnText} )`;
                    btn_no_answer.setAttribute('disabled', 'disabled');

                }, error => {
                    showSwal('something-wrong', '');
                })
        },
        openModalCommentOrConfirmationOrder(e, id, status, type) {
            if (type === 'comment') {
                // Check if shippingComments exists and has the required status
                if (!window.shippingComments || !window.shippingComments[status.toLowerCase()]) {
                    console.error('Shipping comments not found for status:', status);
                    return;
                }

                let comments = window.shippingComments[status.toLowerCase()];
                let options = `<option value="default" selected="selected">Select Follow-up Comment</option>`;

                Object.keys(comments).forEach(key => {
                    // Escape HTML to prevent XSS
                    const escapedKey = this.escapeHtml(key);
                    const escapedValue = this.escapeHtml(comments[key]);
                    options += `<option value="${escapedKey}">${escapedValue}</option>`;
                });

                $('#follow_up_comment').html(options).data('id', id);

                // Bootstrap 5 way to show modal
                const commentModal = new bootstrap.Modal(document.getElementById('modal-add-comment-order'));
                commentModal.show();

            } else if (type === 'confirmation') {
                // Check if shippingVerifications exists
                if (!window.shippingVerifications) {
                    console.error('Shipping verifications not found');
                    return;
                }

                let options = `<option value="default" selected="selected">Select The Right Confirmation</option>`;
                let verifications = window.shippingVerifications;

                Object.keys(verifications).forEach(key => {
                    // Escape HTML to prevent XSS
                    const escapedKey = this.escapeHtml(key);
                    const escapedValue = this.escapeHtml(verifications[key]);
                    options += `<option value="${escapedKey}">${escapedValue}</option>`;
                });

                $('#status_confirmation_order').html(options);
                $('#status_confirmation_order').data('id', id);

                // Bootstrap 5 way to show modal
                const confirmationModal = new bootstrap.Modal(document.getElementById('modal-confirmation-order'));
                confirmationModal.show();
            }
        },

        // Helper function to escape HTML and prevent XSS
        escapeHtml(text) {
            const map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;'
            };
            return text.toString().replace(/[&<>"']/g, function(m) { return map[m]; });
        },

        // addCommentOrConfirmationOrder(type) { // old not used now is addCommentOrConfirmationOrderSingleAction
        //     if (type === 'comment') {
        //         var data = $('#follow_up_comment').data();
        //         Object.assign(data, {status: $('#follow_up_comment').val()});
        //
        //         var commentRadios = document.getElementsByName('commentTypeRadio');
        //
        //         let requestOrRespond = 'respond';
        //
        //         for(i = 0; i < commentRadios.length; i++) {
        //             if(commentRadios[i].checked) {
        //                 requestOrRespond = commentRadios[i].value;
        //             }
        //         }
        //
        //         let endPoint = requestOrRespond == 'request' ? `/api/order/comment-request` : `/api/order/comment-respond`;
        //
        //         axios.post(endPoint, {
        //             orderId: data.id,
        //             comment: data.status,
        //         }).then(response => {
        //             document.getElementById('follow_up_comment_close').click();
        //             Swal.fire("Suceess", "Add Comment to Order Suceessfully", "success");
        //             table.ajax.reload();
        //         }).catch(error => {
        //             this.handleResponseError(error.response.data)
        //         })
        //     } else if (type === 'confirmation') {
        //         var data = $('#status_confirmation_order').data();
        //         Object.assign(data, {status: $('#status_confirmation_order').val(), notes: $('#confirmation_notes').val()});
        //
        //         var validationRadios = document.getElementsByName('validationTypeRadio');
        //
        //         let requestOrRespond = 'respond';
        //
        //         for(i = 0; i < validationRadios.length; i++) {
        //             if(validationRadios[i].checked) {
        //                 requestOrRespond = validationRadios[i].value;
        //             }
        //         }
        //
        //         let endPoint = requestOrRespond == 'request' ? `/api/order/verify-request` : `/api/order/verify-respond`;
        //         var date = '';
        //
        //         if (data.status.includes('POSTPONED')) {
        //             date = document.getElementById('verify_resch').value;
        //
        //             if (!date) {
        //                 Toast.fire({
        //                     icon: 'error',
        //                     title: 'يجب اختيار ميعاد التاجيل'
        //                 });
        //                 return;
        //             }
        //         }
        //
        //         axios.post(endPoint, {
        //             orderId: data.id,
        //             verify: data.status,
        //             notes: data.notes,
        //             date: date
        //         }).then(function (response) {
        //             document.getElementById('confirmation_close').click();
        //             Swal.fire("Suceess", "تم ارسال التوثيق", "success");
        //             table.ajax.reload();
        //         }).catch(error => {
        //             this.handleResponseError(error.response.data)
        //         })
        //     }
        // },

        addCommentOrConfirmationOrderSingleAction(type) {

            if (type === 'comment') {
                var data = $('#follow_up_comment').data();
                Object.assign(data, { status: $('#follow_up_comment').val() });
                Object.assign(data, { comment_notes: $('#comment_notes').val() });

                var commentRadios = document.getElementsByName('commentTypeRadio');
                let requestOrRespond = 'respond';

                for (var i = 0; i < commentRadios.length; i++) {
                    if (commentRadios[i].checked) {
                        requestOrRespond = commentRadios[i].value;
                    }
                }

                let endPoint = requestOrRespond == 'request' ? `/api/order/comment-request` : `/api/order/comment-respond`;

                axios.post(endPoint, {
                    orderId: data.id,
                    comment: data.status,
                    comment_notes: data.comment_notes,
                }).then(response => {
                    table.ajax.reload();
                    // DatatableOrders(); // also you can use this function
                    document.getElementById('follow_up_comment_close').click();
                    Swal.fire("Suceess", "Add Comment to Order Suceessfully", "success");
                }).catch(error => {
                    this.handleResponseError(error.response?.data)
                })
            } else if (type === 'confirmation') {
                var data = $('#status_confirmation_order').data();
                Object.assign(data, { status: $('#status_confirmation_order').val(), notes: $('#confirmation_notes').val() });

                var validationRadios = document.getElementsByName('validationTypeRadio');

                let requestOrRespond = 'respond';

                for (var i = 0; i < validationRadios.length; i++) {
                    if (validationRadios[i].checked) {
                        requestOrRespond = validationRadios[i].value;
                    }
                }

                let endPoint = requestOrRespond == 'request' ? `/api/order/verify-request` : `/api/order/verify-respond`;
                var date = '';

                if (data.status.includes('POSTPONED')) {
                    date = document.getElementById('verify_resch').value;

                    if (!date) {
                        showSwal('custom-wrong', 'يجب اختيار ميعاد التاجيل');
                        return;
                    }
                }

                axios.post(endPoint, {
                    orderId: data.id,
                    verify: data.status,
                    notes: data.notes,
                    date: date
                }).then(function (response) {
                    table.ajax.reload();
                    document.getElementById('confirmation_close').click();
                    Swal.fire("Suceess", "تم ارسال التوثيق", "success");
                }).catch(error => {
                    handleResponseError(error.response.data)
                })
            }
        },

        addCommentOrConfirmationOrder($event, type, orderId, status) {
            if (type === 'comment') {
                var data = $('#follow_up_comment-' + orderId).data();

                Object.assign(data, { status: $('#follow_up_comment-' + orderId).val() });
                Object.assign(data, { comment_notes: $('#comment_notes-' + orderId).val() });

                var commentRadios = document.getElementsByName('commentTypeRadio-' + orderId);

                let requestOrRespond = 'respond';

                for (var i = 0; i < commentRadios.length; i++) {
                    if (commentRadios[i].checked) {
                        requestOrRespond = commentRadios[i].value;
                    }
                }

                let endPoint = requestOrRespond == 'request' ? `/api/order/comment-request` : `/api/order/comment-respond`;

                axios.post(endPoint, {
                    orderId: data.id,
                    comment: data.status,
                    comment_notes: data.comment_notes,
                }).then(response => {
                    Swal.fire("Suceess", "Add Comment to Order Suceessfully", "success");
                }).catch(error => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong!',
                        footer: '<a href>Why do I have this issue?</a>'
                    })
                    // this.handleResponseError(error.response.data)
                })

            } else if (type === 'confirmation') {

                var data = $('#status_confirmation_order-' + orderId).data();
                Object.assign(data, { status: $('#status_confirmation_order-' + orderId).val(), notes: $('#confirmation_notes-' + orderId).val() });

                var validationRadios = document.getElementsByName('validationTypeRadio-' + orderId);

                let requestOrRespond = 'respond';

                for (var i = 0; i < validationRadios.length; i++) {
                    if (validationRadios[i].checked) {
                        requestOrRespond = validationRadios[i].value;
                    }
                }

                let endPoint = requestOrRespond == 'request' ? `/api/order/verify-request` : `/api/order/verify-respond`;
                var date = '';

                if (data.status.includes('POSTPONED')) {
                    date = document.getElementById('verify_resch-' + orderId).value;

                    if (!date) {
                        showSwal('custom-wrong', 'يجب اختيار ميعاد التاجيل');
                        return;
                    }
                }

                axios.post(endPoint, {
                    orderId: data.id,
                    verify: data.status,
                    notes: data.notes,
                    date: date
                }).then(function (response) {
                    Swal.fire("Suceess", "تم ارسال التوثيق", "success");
                }).catch(error => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong!',
                        footer: '<a href>Why do I have this issue?</a>'
                    })
                    // this.handleResponseError(error.response.data)
                })
            }
        },

        assignSelected() {
            let ordersIds = this.getOrderStack();

            // Client-side validation
            if (ordersIds.length === 0) {
                showSwal('custom-wrong', 'Please select at least one order');
                return;
            }

            if (ordersIds.length > 100) {
                showSwal('custom-wrong', 'Maximum 100 orders allowed. You selected ' + ordersIds.length + ' orders. Please reduce your selection.');
                return;
            }

            const companyId = document.getElementById('order-company').value;
            if (!companyId) {
                showSwal('custom-wrong', 'Please select a shipping company');
                return;
            }

            var url = `/api/order/company/assign-pickup`,
                action_type = $(".btn-assign-company").data('type');

            if (action_type == "reassign-company") {
                url = `/api/order/company/reassign-pickup`;
            }

            // Show confirmation with order count and progress indication
            Swal.fire({
                title: 'Assign Orders to Shipping Company?',
                html: `You are about to assign <strong>${ordersIds.length}</strong> order(s).<br>This may take a moment to process.`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Yes, Assign Orders',
                cancelButtonText: 'Cancel',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return axios.post(url, {
                        ordersIds: ordersIds,
                        companyId: companyId
                    })
                    .then(response => response.data)
                    .catch(error => {
                        // Return error data instead of throwing
                        // This allows handleAssignmentResult() to display errors properly
                        return {
                            error: true,
                            ...error.response?.data
                        };
                    });
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                // Handle both success and error cases
                if (result.value) {
                    this.handleAssignmentResult(result.value);
                }
            });
        },

        /**
         * Handle assignment result with detailed feedback
         */
        handleAssignmentResult(data) {
            document.getElementById('close-modal-company').click();

            if (data.error === false) {
                // Full success
                Swal.fire({
                    icon: 'success',
                    title: 'Orders Assigned Successfully!',
                    text: `${data.data?.success_count || 'All'} order(s) assigned to shipping company`,
                    timer: 3000,
                    showConfirmButton: false
                });
            } else {
                // Partial or full failure - show detailed errors
                let errorHtml = '<div class="text-left"><strong>Errors:</strong><ul>';

                if (Array.isArray(data.data)) {
                    data.data.forEach(error => {
                        errorHtml += `<li>${error}</li>`;
                    });
                } else if (typeof data.data === 'object') {
                    Object.entries(data.data).forEach(([orderId, error]) => {
                        errorHtml += `<li><strong>Order #${orderId}:</strong> ${error}</li>`;
                    });
                }

                errorHtml += '</ul></div>';

                Swal.fire({
                    icon: data.message?.includes('Partially') ? 'warning' : 'error',
                    title: data.message || 'Assignment Failed',
                    html: errorHtml,
                    width: 600
                });
            }

            // Refresh DataTable and clear selections
            DatatableOrders();
            $('input[name="check_item"]:checked').prop('checked', false);
            $('.btn-select-all').removeClass('selectedAll');
        },

        assignMultipleShipping() {
            let ordersIds = this.getOrderStack();
            let url = `/api/order/shipping/multiple`;
            const shippingId = document.getElementById('order-shipping').value;
            axios.post(url, {
                ordersIds, shippingId
            }).then(function (response) {
                document.getElementById('close-modal-shipping').click();
                if (response.data.error) {

                    var dataHtml = '';
                    Object.entries(response.data.data).forEach(([i, value]) => {
                        dataHtml += `<li>${value}</li>`;
                    });
                    dataHtml = `<div class="alert alert-danger"><ul> ${dataHtml} </ul></div>`;
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        html: dataHtml,
                        // text: response.data.message,
                        // footer: '<a href="">Why do I have this issue?</a>'
                    });
                } else {
                    Swal.fire("Suceess", 'AssignMultipleShipping', "success");
                }
                let ordersStack = [];
                DatatableOrders();
            }, error => {
                showSwal('something-wrong', '');
            });
        },

        /**
         * Bulk start delivery for multiple orders
         */
        bulkStartDelivery() {
            let ordersIds = this.getOrderStack();

            if (ordersIds.length === 0) {
                showSwal('custom-wrong', 'Please select at least one order');
                return;
            }

            if (ordersIds.length > 25) {
                showSwal('custom-wrong', 'You can only start delivery for up to 25 orders at a time');
                return;
            }

            Swal.fire({
                title: 'Start Delivery for Multiple Orders?',
                text: `You are about to start delivery for ${ordersIds.length} order(s)`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Start Delivery',
                cancelButtonText: 'Cancel',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return axios.post('/api/order/bulk/start-delivery', {
                        ordersIds: ordersIds
                    }).then(response => {
                        return response.data;
                    }).catch(error => {
                        Swal.showValidationMessage(
                            `Request failed: ${error.response?.data?.message || error.message}`
                        );
                    });
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    const data = result.value;
                    let message = `${data.data.success.length} order(s) started successfully`;
                    let icon = 'success';

                    if (data.data.errors.length > 0) {
                        icon = 'warning';
                        message += `\n${data.data.errors.length} order(s) failed`;

                        let errorHtml = '<ul style="text-align: left;">';
                        data.data.errors.forEach(err => {
                            errorHtml += `<li>Order #${err.orderId}: ${err.reason}</li>`;
                        });
                        errorHtml += '</ul>';

                        Swal.fire({
                            title: 'Bulk Start Delivery Results',
                            html: `<p>${message}</p><strong>Errors:</strong>${errorHtml}`,
                            icon: icon
                        });
                    } else {
                        showSwal('successful-operation', message);
                    }

                    DatatableOrders();
                    $('input[name="check_item"]:checked').prop('checked', false);
                    $('.btn-select-all').removeClass('selectedAll');
                }
            });
        },

        /**
         * Helper: Build comment dropdown HTML for SweetAlert
         * Pattern from shipping agent orders.js
         */
        loadCommentsSelect(comments) {
            var data_select = '';
            Object.keys(comments).forEach(key => {
                data_select += `<option value="${key}">${comments[key]}</option>`;
            });

            data_select = `<div class="form-group">
                <label for="swal-bulk-comment" class="col-form-label">اختر التعليق المناسب <span class="text-danger">*</span></label>
                <select id="swal-bulk-comment" class="swal2 form-control" required>
                    <option value="">اختر التعليق المناسب</option>
                    ${data_select}
                </select>
            </div>`;
            return data_select;
        },

        /**
         * Show bulk comment modal for status updates (SweetAlert version)
         */
        showBulkCommentModal(status) {
            let ordersIds = this.getOrderStack();

            if (ordersIds.length === 0) {
                showSwal('custom-wrong', 'Please select at least one order');
                return;
            }

            if (ordersIds.length > 25) {
                showSwal('custom-wrong', 'You can only update up to 25 orders at a time');
                return;
            }

            const comments = window.shippingAgentComments['shipping ' + status.toLowerCase()];
            let order_status = '';
            let data_html = '';

            // Build status-specific HTML
            if (status === 'Scheduled') {
                order_status = "تأجيل";
                data_html += `
                    <div class="form-group">
                        <label for="swal-bulk-schedule-date" class="col-form-label">تاريخ الموعد</label>
                        <input type="date" id="swal-bulk-schedule-date" class="swal2 form-control" required>
                    </div>
                    <div class="form-group">
                        <label for="swal-bulk-schedule-time" class="col-form-label">وقت الموعد</label>
                        <input type="time" id="swal-bulk-schedule-time" class="swal2 form-control" required>
                    </div>`;
            } else if (status === 'Cancelled') {
                order_status = "إلغاء";
            } else if (status === 'No Answer') {
                order_status = "لا يرد";
            } else if (status === 'Delivered') {
                order_status = "تسليم";
            }

            // Notes textarea
            data_html += `
                <div class="form-group">
                    <label for="swal-bulk-notes" class="col-form-label">ملاحظات (اختياري)</label>
                    <textarea id="swal-bulk-notes" class="form-control" rows="3" placeholder="أضف ملاحظات إضافية"></textarea>
                </div>`;

            // Show SweetAlert modal
            Swal.fire({
                title: `${order_status} - ${ordersIds.length} طلبات`,
                html: `
                    <div class="alert alert-info mb-3">
                        <strong>الطلبات المحددة:</strong> ${ordersIds.length}
                        <br>
                        <small>الحد الأقصى 25 طلب</small>
                    </div>
                    ${this.loadCommentsSelect(comments)}
                    ${data_html}
                `,
                showCancelButton: true,
                confirmButtonText: "تأكيد",
                cancelButtonText: "إلغاء",
                width: '600px',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    const comment = document.getElementById('swal-bulk-comment').value;
                    const notes = document.getElementById('swal-bulk-notes').value;
                    let schedule_date = '';
                    let schedule_time = '';

                    // Validation
                    if (!comment) {
                        Swal.showValidationMessage('الرجاء اختيار تعليق');
                        return false;
                    }

                    // Get schedule fields if status is Scheduled
                    if (status === 'Scheduled') {
                        schedule_date = document.getElementById('swal-bulk-schedule-date').value;
                        schedule_time = document.getElementById('swal-bulk-schedule-time').value;

                        if (!schedule_date || !schedule_time) {
                            Swal.showValidationMessage('الرجاء إدخال التاريخ والوقت');
                            return false;
                        }
                    }

                    // Make API call
                    return axios.post('/api/order/bulk/submit-with-comment', {
                        ordersIds: ordersIds,
                        status: status,
                        comment: comment,
                        notes: notes,
                        schedule_date: schedule_date,
                        schedule_time: schedule_time
                    }).then(response => {
                        return response.data;
                    }).catch(error => {
                        Swal.showValidationMessage(
                            `فشل الطلب: ${error.response?.data?.message || error.message}`
                        );
                    });
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    const data = result.value;
                    let message = `${data.data.success.length} طلب تم تحديثه بنجاح`;
                    let icon = 'success';

                    if (data.data.errors.length > 0) {
                        icon = 'warning';
                        message += `\n${data.data.errors.length} طلب فشل`;

                        let errorHtml = '<ul style="text-align: right;">';
                        data.data.errors.forEach(err => {
                            errorHtml += `<li>طلب #${err.orderId}: ${err.reason}</li>`;
                        });
                        errorHtml += '</ul>';

                        Swal.fire({
                            title: 'نتائج العملية الجماعية',
                            html: `<p>${message}</p><strong>الأخطاء:</strong>${errorHtml}`,
                            icon: icon
                        });
                    } else {
                        Swal.fire({
                            title: 'نجح!',
                            text: message,
                            icon: 'success'
                        });
                    }

                    // Refresh table and clear selections
                    DatatableOrders();
                    $('input[name="check_item"]:checked').prop('checked', false);
                    $('.btn-select-all').removeClass('selectedAll');
                }
            });
        },

        assignOrdersToCS() {
            let csFollow = document.getElementById('cs_followup').value
            let ordersIds = this.getOrderStack();

            console.log(ordersIds, csFollow);
            axios.post(`/api/order/customer-support/assign`, {
                orders: ordersIds,
                userId: csFollow,
            }).then(response => {
                document.getElementById('hand-follow-up').click();
                Swal.fire("Suceess", "Assigned Customer Support Suceessfully", "success");
                table.ajax.reload();
            }).catch(error => {
                this.handleResponseError(error.response.data)
            })
        },
        assignSelectedPickUp() {
            axios.post(`/api/order/pickup/multiple`, {
                ordersIds: orderscreatepickup,
                sender_name: $('input[name="sender_name"]').val(),
                recipient_name: $('input[name="recipient_name"]').val()
            }).then(function (response) {
                $('.modal.fade.bd-dispatch-modal-lg .close').click();
                Swal.fire("Suceess", translation.OrderCompanyAssignedSuceessfully, "success");
                DatatableOrders();
            })
        },

        submitCloseOrder(id) {
            var dataQuantities = [];
            var dataPrices = [];
            var dataProducts = [];
            var status = document.getElementById('change-status-' + id).value;
            var worksheet = document.getElementById('worksheet-id-' + id).value;
            var products_id = document.querySelectorAll(`#payment_fields-${id} input[name='product_id[]']`);
            var quantities = document.querySelectorAll(`#payment_fields-${id} input[name='quantity[]']`);
            var prices = document.querySelectorAll(`#payment_fields-${id} input[name='price[]']`);
            var order_price = document.getElementById('order_price-' + id).value;
            var schedule_time = document.getElementById('schedule-time-' + id);
            var delivered_status = document.getElementById('delivered-status-' + id);
            var shipping_amount = document.getElementById('shipping_amount-' + id).value;
            var received_amount = document.getElementById('received_amount-' + id).value;
            var modal = document.getElementById('OrderModalClose-' + id);
            var notes = document.getElementById('notes-' + id);

            quantities.forEach((quantity, index) => {
                dataProducts.push(parseInt(products_id[index].value));
                dataQuantities.push(parseInt(quantity.value));
                dataPrices.push(parseInt(prices[index].value));
            });
            axios.post(`/api/order/${id}/close`, {
                status,
                delivered_status: delivered_status ? delivered_status.value : '',
                worksheet,
                order_price,
                products_id: dataProducts,
                quantities: dataQuantities,
                prices: dataPrices,
                schedule_time: schedule_time ? schedule_time.value : '',
                shipping_amount,
                received_amount,
                notes: notes ? notes.value : '',
            }).then(function (response) {

                if (response.data.error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: response.data.message,
                    });
                } else {
                    modal.click();
                    Swal.fire("Suceess", translation.OrderClosedSuceessfully, "success");
                    DatatableOrders();
                }
            }, error => {
                if (error.response.data.errors) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        html: this.printErrorMsg(error.response.data.errors),
                        footer: '<a href="">Why do I have this issue?</a>'
                    });

                } else {
                    this.handleResponseError(error.response.data);
                }
            })
        },

        // submitCloseOrder(id, verify) {
        //     var url = ['PARTIAL_DELIVERY', 'COMPLETE_DELIVERY'].includes(verify) ? `/api/order/${id}/close-delivery` : `/api/order/${id}/close`;
        //     var worksheet = document.getElementById('worksheet-id-'+id).value;
        //     var order_price = document.getElementById('order_price-'+id).value;
        //     var quantity = document.getElementById('quantity-'+id).value;
        //     var schedule_time = document.getElementById('schedule-time-'+id);
        //     var shipping_amount = document.getElementById('shipping_amount-'+id).value;
        //     var received_amount = document.getElementById('received_amount-'+id).value;
        //     var modal = document.getElementById('OrderModalClose-'+id);
        //     var notes = document.getElementById('notes-'+id);
        //
        //     axios.post(url,{
        //         worksheet,
        //         order_price,
        //         quantity,
        //         schedule_time: schedule_time ? schedule_time.value : '',
        //         shipping_amount,
        //         received_amount,
        //         notes: notes ? notes.value : '',
        //     })
        //         .then(function (response) {
        //             modal.click();
        //             showSwal('successful-opperation', response.data.message);
        //             DatatableOrders();
        //         }, error => {
        //             showSwal('something-wrong', '');
        //         })
        // },
        oldsubmitCloseOrder(id) { // old
            var worksheet = document.getElementById('worksheet-id-' + id).value;
            var status = document.getElementById('change-status-' + id).value;
            var schedule_time = document.getElementById('schedule-time-' + id).value;
            var return_status = document.getElementById('return-status-' + id).value;
            var return_qty = document.getElementById('returns-qty-' + id).value;
            var return_doc = document.getElementById('returns-doc-' + id).value;
            var order_price = document.getElementById('order_price-' + id).value;
            var quantity = document.getElementById('quantity-' + id).value;
            var shipping_amount = document.getElementById('shipping_amount-' + id).value;
            var payment_method = document.getElementById('payment-method-' + id).value;
            var from = document.getElementById('from-' + id).value;
            var to = document.getElementById('to-' + id).value;
            var payment_note = document.getElementById('payment-note-' + id).value;
            var received_amount = document.getElementById('received_amount-' + id).value;
            var feedback = document.getElementById('shipping-comment-' + id).value;
            var modal = document.getElementById('OrderModalClose-' + id);

            axios.post(`/api/order/${id}/close`, {
                worksheet: worksheet,
                status: status,
                schedule_time: schedule_time,
                return_status: return_status,
                return_qty: return_qty,
                return_doc: return_doc,
                order_price: order_price,
                quantity: quantity,
                shipping_amount: shipping_amount,
                payment_method: payment_method,
                payment_note: payment_note,
                received_amount: received_amount,
                from: from,
                to: to,
                shipping_comment: feedback,
            })
                .then(function (response) {
                    $('#newLeadForm').trigger('reset');
                    modal.click();
                    showSwal('successful-opperation', response.data.message);
                    DatatableOrders();
                }, error => {
                    showSwal('something-wrong', '');
                })
        },

        assignPaymentMethod() {
            let ordersIds = this.getOrderStack();
            if (ordersIds.length === 0) {
                var errorMessage = document.getElementById("error_message");
                if (errorMessage.style.display === "none") {
                    errorMessage.style.display = "block";
                }
                return;
            }

            axios.post('/api/order/assign-paymentmethod-to-order', {
                order_id: ordersIds,
                payment_method_id: $("#payment_method").val(),
                account_number_id: $("#account_number").val()
            }).then(function (response) {
                $('.modal.fade .close').click();
                Swal.fire("Suceess", response.data.message, "success");
                DatatableOrders();
            });
        },
        approvalOrdersPendingAmount() {
            if (!ordersCreateTransactionIds.length) {
                showSwal('custom-wrong', 'يجب اختيار اوردر واحد على الاقل');
                return;
            }

            Swal.fire({
                title: "Are you sure ?",
                text: "You will approval this Orders To Collected.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, change it !",
                cancelButtonText: "No, cancel !",
                closeOnConfirm: false,
                closeOnCancel: false
            }).then((confirmed) => {
                console.log(confirmed);
                if (confirmed.value == true) {
                    axios.post(`/api/order/approval-pending-amount/multiple`, {
                        orders: ordersCreateTransactionIds,
                    }).then(function (response) {
                        Swal.fire("Suceess", response.data.message, "success");
                        // Swal.fire("Suceess", translation.approvalOrdersPendingAmountSuceessfully, "success");
                        DatatableOrders();
                    }, error => {
                        if (error.response.data.errors) {
                            console.log(error.response);
                            Swal.fire({
                                icon: 'error',
                                title: 'Oops...',
                                html: this.printErrorMsg(error.response.data.errors),
                                footer: '<a href="">Why do I have this issue?</a>'
                            });

                        } else {
                            this.handleResponseError(error.response.data);
                        }
                        return;
                    })

                } else if (confirmed.dissmiss == "cancel") {
                    Swal.fire("Cancelled", "Status Unchanged !", "error");

                }
            });
        },
        updateQtyAndPrice($event, orderId) {
            Swal.fire({
                title: "Are you sure ?",
                text: "You will create Request Update Qty And Price.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, change it !",
                cancelButtonText: "No, cancel !",
                closeOnConfirm: false,
                closeOnCancel: false
            }).then((confirmed) => {
                if (confirmed.value == true) {
                    // var quantity = document.getElementById(`edit_order_quantity-${orderId}`).value;
                    // var price = document.getElementById(`edit_order_price-${orderId}`).value;
                    var data = document.getElementById(`edit_order_data-${orderId}`);

                    var product_id = [];
                    var actual_product_id = [];
                    var quantity = [];
                    var actual_quantity = [];
                    var price = [];
                    var actual_price = [];
                    var order_product_id = [];

                    var lastname_id = $('div.pro2').last().attr('id'),
                        split_id    = lastname_id.split('_'),
                        index       = Number(split_id[1]);

                    $('div.pro2 .product-select').attr("id","lead-product-"+index).each(function (index) {
                        product_id.push(this.value)
                    });
                    $('div.pro2 .actualproduct-select').attr("id","actualproduct-select-"+index).each(function (index) {
                        actual_product_id.push(this.value)
                    });
                    $('div.pro2 .leadamount').attr("id","leadamount-"+index).each(function (index) {
                        quantity.push(this.value)
                    });
                    $('div.pro2 .actualleadamount').attr("id","actualleadamount-"+index).each(function (index) {
                        actual_quantity.push(this.value)
                    });
                    $('div.pro2 .leadtotalprice').attr("id","leadtotalprice-"+index).each(function (index) {
                        price.push(this.value)
                    });
                    $('div.pro2 .actualleadtotalprice').attr("id","actualleadtotalprice-"+index).each(function (index) {
                        actual_price.push(this.value)
                    });

                    $('div.pro2 .product-order').attr("id","product-order-"+index).each(function (index) {
                        order_product_id.push(this.value)
                    });

                    axios.post(`/api/order/edit-orders/store`,{
                        product_id,
                        actual_product_id,
                        quantity,
                        actual_quantity,
                        price,
                        actual_price,
                        order_product_id,
                        order_id: data.getAttribute('data-orderid'),
                        user_id: data.getAttribute('data-userid')
                    }).then(function (response) {
                        Swal.fire("Success", "Order Updated Successfully", "success");
                        if (response.data.error == true) {
                            Swal.fire("Cancelled", "The shipping company doesn't have enough quantity", "error");
                        }
                    }, error => {
                    })

                } else if (confirmed.dissmiss == "cancel") {
                    Swal.fire("Cancelled", "Status Unchanged !", "error");
                }
            });

        },
        copyURLToPBI($event, page_title = null) {
            let _url = window.tableUrl;
            const {
                host, hostname, href, origin, pathname, port, protocol, search
              } = window.location

            _url = `${origin}/api/order/${page_title}?${_url.slice(_url.indexOf('?') + 1)}`;
            navigator.clipboard.writeText(_url);
        },

        submitAddFeedback($event, id) {
            var type = document.getElementById('feeback-type-'+id).value;
            var status = document.getElementById('change-status-'+id).value;
            var schedule_time = document.getElementById('schedule-time-'+id).value;
            var feedback = document.getElementById('status-comment-'+id).value;
            var modal = document.getElementById('OrderModalFeedback-'+id);

            axios.post(`/api/order/${id}/feedback`,{
                status: status,
                schedule_time: schedule_time,
                comment: feedback,
                type: type,
            })
            .then(function (response) {
                $('#newLeadForm').trigger('reset');
                modal.click();
                showSwal('successful-opperation', response.data.message);
                DatatableOrders();
            }, error => {
                showSwal('something-wrong', '');
            })
        },

        submitAddLiability($event, id) {
            var liability = document.getElementById('change-liability-'+id).value;
            var modal = document.getElementById('OrderModalLiability-'+id);

            axios.post(`/api/order/${id}/liability`,{
                liability: liability,
            })
            .then(function (response) {
                $('#newLeadForm').trigger('reset');
                modal.click();
                showSwal('successful-opperation', response.data.message);
                DatatableOrders();
            }, error => {
                showSwal('something-wrong', '');
            })
        },

        // ---- Start Print Error
        printErrorMsg(msg) {
            var ulElements = '';
            $.each(msg, function (key, value) {
                ulElements += `<li>${value[0]}</li>`;
            });
            return `<div class="alert alert-danger print-error-msg">${ulElements}</div>`;
        },

        handleResponseError(error) {
            if (error.errors) {
                let errors = error.errors
                for (key in errors) {
                    showSwal('custom-wrong', errors[key][0]);
                }
            } else {
                showSwal('custom-wrong', error.message);
            }
        },
        // ---- End Print Error

        // ------ Start Code Page 'delivered-collected' and any fun to modal opened from this page --------------
        // ------------------------------------------------------------------------------------------------------
        createAnAgentAccount($event, ordersIDs) {

            $('#btnSubmit').attr("disabled", true);

            axios.post(`/api/transactions/create-new`, {
                orders: ordersIDs,
                payment_method_id: $("#payment_method").val(),
                account_number_id: $("#account_number").val(),
                notes: $("#notes").val()
            }).then(function (response) {
                if (response.data.status_code === 422) {
                    showSwal('custom-wrong', response.data.message);
                } else {
                    showSwal('successful-opperation', 'تم انشاء حساب مندوب');
                    document.getElementById('close-modal-create-transaction').click();
                    DatatableOrders();
                }
            }, error => {
                if (error.response.data.errors) {
                    console.log(error.response);
                    var ulElements = '';
                    $.each( error.response.data.errors, function( key, value ) {
                        ulElements += `<li>${value[0]}</li>`;
                    });
                    $('div.print-error-msg').append(`<ul>${ulElements}</ul>`).removeClass('d-none');
                }

            })

        }
        // ------ End Code Page 'delivered-collected' --------------

    }; // End Return Alpine js
}
